/* eslint-disable no-dupe-keys */
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  Box,
  IconButton,

  //Typography,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import TextField from "@material-ui/core/TextField";
import { useState, useContext } from "react";
import SFDialogTitle from "./SFDialogTitle";

import { PaymentCreateContext } from "../pages/payment/payment-addproduct/PaymentCreateContext";
import useOffersInfo from "../hooks/useOfferInfo";
import { Loading } from "ra-ui-materialui";
import CircleToggleButtonItem from "./CircleToggleButton";
import useCheckAuthorizeCode from "../hooks/useCheckAuthorizeCode";
import { useTranslate } from "react-admin";

import useSFAlert from "../hooks/useSFAlert";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 667,

    margin: "0 auto",
    paddingTop: 50,
  },
  title: {
    fontSize: 30,
    color: theme.orange,
  },
  paper: {
    margin: 0,
    width: 550,
    borderRadius: "10px",
    maxWidth: 667,
  },
  dialogContent: {
    display: "flex",
    // gridTemplateRows: "100px 1fr 100px",
    margin: "0 auto",
    overflow: "hidden",
    //  flexDirection: "column",
    padding: 10,
    alignItems: "center",
    // width:"400px",
    // height:"100px",
    // overflow: "scroll",
  },
  toggleButtonGroup: {},
  toggleButton: {
    width: 150,
    height: 38,
  },
  selected: {
    backgroundColor: theme.orange + " !important",
    color: theme.white,
  },
  nonSelected: {
    color: theme.orange,
  },

  discountTextField: {
    marginTop: 31,
    width: 426,
    height: 66,
  },
  authorizeTextField: {
    width: 396,
    height: 66,
    marginBottom: 20,
  },
  circleItem: {
    width: 77,
    height: 77,
    marginBottom: 17,
    borderRadius: 37,
    borderWidth: 1,
    borderColor: "#b00020",
  },
  circleItemsContainer: {
    display: "grid",
    height: "100px ",
    overflow: "scroll",
    overflowX: "Hidden",

    // display: "flex",
    width: "400px",
    padding: 10,
    marginTop: 17,
    gridTemplateColumns: "33% 33% 34%",
    gridAutoRows: "auto",
    gridGap: 10,
    justifyItems: "center",
    maxHeight: "100%",
    boxSizing: "border-box",
    //  justifyContent: "space-around",
    alignItems: "center",
  },
  dialogAction: {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    margin: "0 !important",
  },
  button: {
    height: 69,
    minHeight: 69,
    fontSize: 26,
    margin: "0 !important",
    borderRadius: "0px 0px",
  },
}));

const DiscountDialog = () => {
  const classes = useStyles();

  const [alert] = useSFAlert();
  const { checkAuth } = useCheckAuthorizeCode();
  const [toggleValue, setToggleValue] = useState("%");
  const [showPassword, setShowPassword] = useState(false);
  const [offerSelection, setOfferSelection] = useState("");
  const [pin, setPin] = useState("");
  const { loading, offers, error } = useOffersInfo();
  const [state, dispatch] = useContext(PaymentCreateContext);
  const [openDiscount, setOpenDiscount] = useState();
  const translate = useTranslate();
  const handleToggleGroupChange = (_, newValue) => {
    if (!newValue) return; //Prevent unselect tab
    setOfferSelection("");
    setOpenDiscount();
    setPin("");
    return setToggleValue(newValue);
  };

  if (loading) return <Loading />;
  if (error) return null;

  const handleCloseDialog = () => {
    // setOfferSelection("");
    setOpenDiscount();
    setPin("");
    return dispatch({
      type: "HIDE_DISCOUNT",
      payload: null,
    });
  };

  return (
    <Dialog
      onClose={handleCloseDialog}
      aria-labelledby="customized-dialog-title"
      open={state.showDiscountDialog}
      classes={{
        root: classes.allContainer,
        paper: classes.paper,
      }}
    >
      <SFDialogTitle
        id="customized-dialog-title"
        onClose={handleCloseDialog}
        title={translate("ra.text.discount")}
        subtitle={translate("ra.text.canUseOnlyOneDiscount")}
      />

      <ToggleButtonGroup
        style={{ margin: "0 auto" }}
        classes={{ grouped: classes.toggleButton }}
        value={toggleValue}
        exclusive
        onChange={handleToggleGroupChange}
        aria-label="Discount type"
      >
        <ToggleButton
          value="%"
          aria-label="percent"
          classes={{
            root: classes.nonSelected,
            selected: classes.selected,
          }}
        >
          %
        </ToggleButton>
        <ToggleButton
          value="amount"
          aria-label="amount"
          classes={{
            root: classes.nonSelected,
            selected: classes.selected,
          }}
        >
          {translate("ra.text.amount")}
        </ToggleButton>
        <ToggleButton
          value="code"
          aria-label="code"
          classes={{
            root: classes.nonSelected,
            selected: classes.selected,
            hover: classes.hover,
          }}
          disabled
        >
          {translate("ra.text.code")}
        </ToggleButton>
      </ToggleButtonGroup>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <CircleList
          discountType={toggleValue}
          offers={offers}
          offerSelection={offerSelection}
          setOfferSelection={(data) => {
            setOfferSelection(data);
            setOpenDiscount();
          }}
        />
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <TextField
          label={toggleValue === "amount" ? translate("ra.text.amount") : "%"}
          variant="outlined"
          classes={{ root: classes.authorizeTextField }}
          onChange={(e) => setOpenDiscount(Math.abs(e.target.value))}
          type="number"
          value={String(openDiscount)}
          disabled={
            !offerSelection ||
            offerSelection === "" ||
            !isOfferisFreeValue(offerSelection)
          }
        ></TextField>
        <TextField
          type={showPassword ? "text" : "password"}
          label={translate("ra.text.management.authorizationCode")}
          classes={{ root: classes.authorizeTextField }}
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button
          onClick={async () => {
            if (!offerSelection || offerSelection === "") {
              dispatch({
                type: "APPLY_DISCOUNT",
                payload: { discount: null },
              });
              return dispatch({
                type: "HIDE_DISCOUNT",
              });
            }

            if (offerSelection.pin) {
              const result = await checkAuth({
                offerId: offerSelection.id,
                pin: pin,
              });
              if (result.error) {
                setPin("");

                return alert(translate("ra.text.wrongAuthorizeCode"));
              }
            }

            dispatch({
              type: "HIDE_DISCOUNT",
            });

            offerSelection.pin = pin;
            if (
              openDiscount &&
              openDiscount !== "" &&
              isOfferisFreeValue(offerSelection)
            ) {
              offerSelection.coupons[0].value = openDiscount;
              dispatch({
                type: "APPLY_DISCOUNT",
                payload: { discount: offerSelection },
              });
            } else {
              dispatch({
                type: "APPLY_DISCOUNT",
                payload: { discount: offerSelection },
              });
            }
            setPin("");
            //setOpenDiscount();
            return; //setOfferSelection("");
          }}
          color="primary"
          fullWidth
          variant="contained"
          classes={{ contained: classes.button }}
          disabled={false}
        >
          {translate("ra.text.addProduct.applyDiscount")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const CircleList = ({
  discountType,
  offers,
  setOfferSelection,
  offerSelection,
}) => {
  const classes = useStyles();
  let couponType = "";
  if (discountType === "%") {
    couponType = "Discount Percent";
  }

  if (discountType === "amount") {
    couponType = "Discount";
  }

  if (discountType === "code") {
    couponType = "code";
  }

  return (
    <Box classes={{ root: classes.circleItemsContainer }}>
      {offers
        ?.filter((offer) => {
          if (offer.coupons && offer.coupons.length > 0)
            return offer.coupons[0].type === couponType;
          else return false;
        })
        .map((offer) => (
          <CircleToggleButtonItem
            label={offer.name}
            onClick={() => {
              if (offer.id === offerSelection?.id) setOfferSelection(null);
              else setOfferSelection(offer.clone());
            }}
            imgUrl={offer.image_url}
            conditions={offer.conditions}
            selected={offer.id === offerSelection?.id}
          />
        ))}
    </Box>
  );
};

const isOfferisFreeValue = (offer) => {
  return offer.coupons[0].value === 0;
};

export default DiscountDialog;
